import { render, staticRenderFns } from "./merit.vue?vue&type=template&id=79396eea&scoped=true"
import script from "./merit.vue?vue&type=script&lang=js"
export * from "./merit.vue?vue&type=script&lang=js"
import style0 from "./merit.vue?vue&type=style&index=0&id=79396eea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_8c4e5e0a3a88c7932152ef02627e3518/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79396eea",
  null
  
)

export default component.exports